import React from "react";
import CmDictService from "./CmDictService";
import {getCmDict, setCmDict, DICT_KEY} from "../utils/constants";


const cmDictModel = {
    state: {
        //组织机构树
        orgDict: getCmDict(DICT_KEY.CM_DICT.ORG),
        warehouseDict: getCmDict(DICT_KEY.CM_DICT.WAREHOUSE),
        areaDict: getCmDict(DICT_KEY.CM_DICT.AREA),
        shelveDict: getCmDict(DICT_KEY.CM_DICT.SHELVE),
        positionDict: getCmDict(DICT_KEY.CM_DICT.POSITION),
        //供应商列表字典
        supplierDict: getCmDict(DICT_KEY.CM_DICT.SUPPLIER),
        //客户列表字典
        customerDict: getCmDict(DICT_KEY.CM_DICT.CUSTOMER),
        //品牌字典
        brandDict: getCmDict(DICT_KEY.CM_DICT.BRAND),
        //发动机型号
        engineTypeDict: getCmDict(DICT_KEY.CM_DICT.ENGINE_TYPE),
        //发动机型号
        materialUnitDict: getCmDict(DICT_KEY.CM_DICT.MATERIAL_UNIT),
        //配件类型字典
        materialSortDict: getCmDict(DICT_KEY.CM_DICT.MATERIAL_SORT),

        //供应商类型字典
        supplierTypeDict: getCmDict(DICT_KEY.CM_DICT.SUPPLIER_TYPE),
        //客户类型字典
        customerTypeDict: getCmDict(DICT_KEY.CM_DICT.CUSTOMER_TYPE),

        //支付方式字典
        payTypeDict: getCmDict(DICT_KEY.CM_DICT.PAY_TYPE),
        //支付状态
        payStatusDict: getCmDict(DICT_KEY.CM_DICT.PAY_STATUS),
        //出库状态
        whOutStatusDict: getCmDict(DICT_KEY.CM_DICT.WH_OUT_STATUS),
        //入库状态
        whInStatusDict: getCmDict(DICT_KEY.CM_DICT.WH_IN_STATUS),

        //发票类型字典
        invoiceTypeDict: getCmDict(DICT_KEY.CM_DICT.INVOICE_TYPE),

        //销售订单类型（常规、直发）
        saleOrderTypeDict: getCmDict(DICT_KEY.CM_DICT.SALE_ORDER_TYPE),
        //售价类型(销售价、二级销价）
        salePriceTypeDict: getCmDict(DICT_KEY.CM_DICT.SALE_PRICE_TYPE),
        //销售订单状态字典
        saleOrderStatusDict: getCmDict(DICT_KEY.CM_DICT.SALE_ORDER_STATUS),
        //销售单状态字典
        saleStatusDict: getCmDict(DICT_KEY.CM_DICT.SALE_STATUS),
        //销售退货单状态字典
        saleReturnStatusDict: getCmDict(DICT_KEY.CM_DICT.SALE_RETURN_STATUS),

        //采购定单类型
        purchaseOrderTypeDict: getCmDict(DICT_KEY.CM_DICT.PURCHASE_ORDER_TYPE),
        //采购订单状态字典
        purchaseOrderStatusDict: getCmDict(DICT_KEY.CM_DICT.PURCHASE_ORDER_STATUS),
        //采购发运单状态字典
        purchaseInvoiceStatusDict: getCmDict(DICT_KEY.CM_DICT.PURCHASE_INVOICE_STATUS),
        //采购单状态字典
        purchaseStatusDict: getCmDict(DICT_KEY.CM_DICT.PURCHASE_STATUS),
        //采购退货单状态字典
        purchaseReturnStatusDict: getCmDict(DICT_KEY.CM_DICT.PURCHASE_RETURN_STATUS),
        //盘点状态字典
        stockCheckStatusDict: getCmDict(DICT_KEY.CM_DICT.STOCK_CHECK_STATUS),
        //账户类型字典
        //单据类型字典
        billsTypeDict: getCmDict(DICT_KEY.CM_DICT.BillS_TYPE),
        //收款状态
        payeeTypeDict: getCmDict(DICT_KEY.CM_DICT.PAYEE_TYPE),

        accountTypeDict: getCmDict(DICT_KEY.CM_DICT.ACCOUNT_TYPE),
        //销售单支付状态
        salePayStatusDict: getCmDict(DICT_KEY.CM_DICT.SALE_PAY_STATUS),
        //销售退货单支付状态
        saleReturnPayStatusDict: getCmDict(DICT_KEY.CM_DICT.SALE_RETURN_PAY_STATUS),
        //采购单支付状态
        purchasePayStatusDict: getCmDict(DICT_KEY.CM_DICT.PURCHASE_PAY_STATUS),
        //采购退货单支付状态
        purchaseReturnPayStatusDict: getCmDict(DICT_KEY.CM_DICT.PURCHASE_RETURN_PAY_STATUS),
        //开户银行类型
        opnBankDict: getCmDict(DICT_KEY.CM_DICT.OPENBANK_TYPE)
    },

    reducers: {
        setOrgDict(state, payload) {
            state.orgDict = payload;
            setCmDict(DICT_KEY.CM_DICT.ORG, payload);
        },
        setWarehouseDict(state, payload) {
            state.warehouseDict = payload;
            setCmDict(DICT_KEY.CM_DICT.WAREHOUSE, payload);
        },
        setAreaDict(state, payload) {
            state.areaDict = payload;
            setCmDict(DICT_KEY.CM_DICT.AREA, payload);
        },
        setShelveDict(state, payload) {
            state.shelveDict = payload;
            setCmDict(DICT_KEY.CM_DICT.SHELVE, payload);
        },
        setPositionDict(state, payload) {
            state.positionDict = payload;
            setCmDict(DICT_KEY.CM_DICT.POSITION, payload);
        },
        setSupplierDict(state, payload) {
            state.supplierDict = payload;
            setCmDict(DICT_KEY.CM_DICT.SUPPLIER, payload);
        },
        setCustomerDict(state, payload) {
            state.customerDict = payload;
            setCmDict(DICT_KEY.CM_DICT.CUSTOMER, payload);
        },
        setBrandDict(state, payload) {
            state.brandDict = payload;
            setCmDict(DICT_KEY.CM_DICT.BRAND, payload);
        },
        setEngineTypeDict(state, payload) {
            state.engineTypeDict = payload;
            setCmDict(DICT_KEY.CM_DICT.ENGINE_TYPE, payload);
        },
        setMaterialUnitDict(state, payload) {
            state.materialUnitDict = payload;
            setCmDict(DICT_KEY.CM_DICT.MATERIAL_UNIT, payload);
        },
        setMaterialSortDict(state, payload) {
            state.materialSortDict = payload;
            setCmDict(DICT_KEY.CM_DICT.MATERIAL_SORT, payload);
        },

        setSupplierTypeDict(state, payload) {
            state.supplierTypeDict = payload;
            setCmDict(DICT_KEY.CM_DICT.SUPPLIER_TYPE, payload);
        },
        setCustomerTypeDict(state, payload) {
            state.customerTypeDict = payload;
            setCmDict(DICT_KEY.CM_DICT.CUSTOMER_TYPE, payload);
        },
        setPayTypeDict(state, payload) {
            state.payTypeDict = payload;
            setCmDict(DICT_KEY.CM_DICT.PAY_TYPE, payload);
        },
        setWhOutStatusDict(state, payload) {
            state.whOutStatusDict = payload;
            setCmDict(DICT_KEY.CM_DICT.WH_OUT_STATUS, payload);
        },
        setWhInStatusDict(state, payload) {
            state.whInStatusDict = payload;
            setCmDict(DICT_KEY.CM_DICT.WH_IN_STATUS, payload);
        },
        setPayStatusDict(state, payload) {
            state.payStatusDict = payload;
            setCmDict(DICT_KEY.CM_DICT.PAY_STATUS, payload);
        },
        //发票类型字典
        setInvoiceTypeDict(state, payload) {
            state.invoiceTypeDict = payload;
            setCmDict(DICT_KEY.CM_DICT.INVOICE_TYPE, payload);
        },
        //销售订单类型（常规、直发）
        setSaleOrderTypeDict(state, payload) {
            state.saleOrderTypeDict = payload;
            setCmDict(DICT_KEY.CM_DICT.SALE_ORDER_TYPE, payload);
        },
        //销售价格类型（常规、直发）
        setSalePriceTypeDict(state, payload) {
            state.salePriceTypeDict = payload;
            setCmDict(DICT_KEY.CM_DICT.SALE_PRICE_TYPE, payload);
        },
        //销售订单状态字典
        setSaleOrderStatusDict(state, payload) {
            state.saleOrderStatusDict = payload;
            setCmDict(DICT_KEY.CM_DICT.SALE_ORDER_STATUS, payload);
        },
        //销售单状态字典
        setSaleStatusDict(state, payload) {
            state.saleStatusDict = payload;
            setCmDict(DICT_KEY.CM_DICT.SALE_STATUS, payload);
        },
        //销售退货单状态字典
        setSaleReturnStatusDict(state, payload) {
            state.saleReturnStatusDict = payload;
            setCmDict(DICT_KEY.CM_DICT.SALE_RETURN_STATUS, payload);
        },

        //设置采购单类型
        setPurchaseOrderTypeDict(state, payload) {
            state.purchaseOrderTypeDict = payload;
            setCmDict(DICT_KEY.CM_DICT.PURCHASE_ORDER_TYPE, payload);
        },
        //采购订单状态字典
        setPurchaseOrderStatusDict(state, payload) {
            state.purchaseOrderStatusDict = payload;
            setCmDict(DICT_KEY.CM_DICT.PURCHASE_ORDER_STATUS, payload);
        },
        //采购发运单状态字典
        setPurchaseInvoiceStatusDict(state, payload) {
            state.purchaseInvoiceStatusDict = payload;
            setCmDict(DICT_KEY.CM_DICT.PURCHASE_INVOICE_STATUS, payload);
        },
        //采购单状态字典
        setPurchaseStatusDict(state, payload) {
            state.purchaseStatusDict = payload;
            setCmDict(DICT_KEY.CM_DICT.PURCHASE_STATUS, payload);
        },
        //采购退货单状态字典
        setPurchaseReturnStatusDict(state, payload) {
            state.purchaseReturnStatusDict = payload;
            setCmDict(DICT_KEY.CM_DICT.PURCHASE_RETURN_STATUS, payload);
        },
        setStockCheckStatusDict(state, payload) {
            state.stockCheckStatusDict = payload;
            setCmDict(DICT_KEY.CM_DICT.STOCK_CHECK_STATUS, payload);
        },
        //账户类型字典
        setAccountTypeDict(state, payload) {
            state.accountTypeDict = payload;
            setCmDict(DICT_KEY.CM_DICT.ACCOUNT_TYPE, payload);
        },
        //单据字典
        setBillsTypeDict(state, payload) {
            state.billsTypeDict = payload;
            setCmDict(DICT_KEY.CM_DICT.BillS_TYPE, payload);
        },
        //收款状态
        setPayeeTypeDict(state, payload) {
            state.payeeTypeDict = payload;
            setCmDict(DICT_KEY.CM_DICT.PAYEE_TYPE, payload);
        },
        setSalePayStatusDict(state, payload) {
            state.salePayStatusDict = payload;
            setCmDict(DICT_KEY.CM_DICT.SALE_PAY_STATUS, payload);
        },
        setSaleReturnPayStatusDict(state, payload) {
            state.saleReturnPayStatusDict = payload;
            setCmDict(DICT_KEY.CM_DICT.SALE_RETURN_PAY_STATUS, payload);
        },
        setPurchasePayStatusDict(state, payload) {
            state.purchasePayStatusDict = payload;
            setCmDict(DICT_KEY.CM_DICT.PURCHASE_PAY_STATUS, payload);
        },
        setPurchaseReturnPayStatusDict(state, payload) {
            state.purchaseReturnPayStatusDict = payload;
            setCmDict(DICT_KEY.CM_DICT.PURCHASE_RETURN_PAY_STATUS, payload);
        },
        //设置银行类型
        setOpnBankDict(state, payload) {
            state.opnBankDict = payload;
            setCmDict(DICT_KEY.CM_DICT.OPENBANK_TYPE, payload);
        },


    },

    effects: () => ({
        async getOrgDict(force, rootState) {

            const {cmDict} = rootState;
            let {orgDict} = cmDict;
            if (force || !!!orgDict || orgDict.length === 0) {
                let ret = await CmDictService.getOrgDict();
                this.setOrgDict(ret);
            }
        },
        async getWarehouseDict(force, rootState) {
            const {cmDict} = rootState;
            let {warehouseDict} = cmDict;
            if (force || !!!warehouseDict || warehouseDict.length === 0) {
                let ret = await CmDictService.getWarehouseDict();
                this.setWarehouseDict(ret);
            }
        },
        async getAreaDict(force, rootState) {
            const {cmDict} = rootState;
            let {areaDict} = cmDict;
            if (force || !!!areaDict || areaDict.length === 0) {
                let ret = await CmDictService.getAreaDict();
                this.setAreaDict(ret);
            }
        },
        async getShelveDict(force, rootState) {
            const {cmDict} = rootState;
            let {shelveDict} = cmDict;
            if (force || !!!shelveDict || shelveDict.length === 0) {
                let ret = await CmDictService.getShelveDict();
                this.setShelveDict(ret);
            }
        },
        async getPositionDict(force, rootState) {
            const {cmDict} = rootState;
            let {positionDict} = cmDict;
            if (force || !!!positionDict || positionDict.length === 0) {
                let ret = await CmDictService.getPositionDict();
                this.setPositionDict(ret);
            }
        },
        async getSupplierDict(force = false, rootState) {
            const {cmDict} = rootState;
            let {supplierDict} = cmDict;
            if (force || !!!supplierDict || supplierDict.length === 0) {
                let ret = await CmDictService.getSupplierDict();
                this.setSupplierDict(ret);
            }
        },
        async getCustomerDict(force = false, rootState) {
            const {cmDict} = rootState;
            let {customerDict} = cmDict;
            if (force || !!!customerDict || customerDict.length === 0) {
                let ret = await CmDictService.getCustomerDict();
                this.setCustomerDict(ret);
            }
        },
        async getAccountTypeDict(force = false, {cmDict}) {
            let {accountTypeDict} = cmDict;
            if (force || !!!accountTypeDict || accountTypeDict.length === 0) {
                let ret = await CmDictService.getAccountTypeDict()
                this.setAccountTypeDict(ret)
            }
        },
        async getBrandDict(force, rootState) {
            const {cmDict} = rootState;
            let {brandDict} = cmDict;
            if (force || !!!brandDict || brandDict.length === 0) {
                let ret = await CmDictService.getBrandDict();
                this.setBrandDict(ret);
            }
        },
        async getEngineTypeDict(force, rootState) {
            const {cmDict} = rootState;
            let {engineTypeDict} = cmDict;
            if (force || !!!engineTypeDict || engineTypeDict.length === 0) {
                let ret = await CmDictService.getEngineTypeDict();
                this.setEngineTypeDict(ret);
            }
        },
        async getMaterialUnitDict(force, rootState) {
            const {cmDict} = rootState;
            let {materialUnitDict} = cmDict;
            if (force || !!!materialUnitDict || materialUnitDict.length === 0) {
                let ret = await CmDictService.getMaterialUnitDict();
                this.setMaterialUnitDict(ret);
            }
        },
        async getMaterialSortDict(force, rootState) {
            const {cmDict} = rootState;
            let {materialSortDict} = cmDict;
            if (force || !!!materialSortDict || materialSortDict.length === 0) {
                let ret = await CmDictService.getMaterialSortDict();
                this.setMaterialSortDict(ret);
            }
        },

        async getSupplierTypeDict(force, rootState) {
            const {cmDict} = rootState;
            let {supplierTypeDict} = cmDict;
            if (force || !!!supplierTypeDict || supplierTypeDict.length === 0) {
                let ret = await CmDictService.getSupplierTypeDict();
                this.setSupplierTypeDict(ret);
            }
        },
        async getCustomerTypeDict(force, rootState) {
            const {cmDict} = rootState;
            let {customerTypeDict} = cmDict;
            if (force || !!!customerTypeDict || customerTypeDict.length === 0) {
                let ret = await CmDictService.getCustomerTypeDict();
                this.setCustomerTypeDict(ret);
            }
        },
        async getPayTypeDict(force, rootState) {
            const {cmDict} = rootState;
            let {payTypeDict} = cmDict;
            if (force || !!!payTypeDict || payTypeDict.length === 0) {
                let ret = await CmDictService.getPayTypeDict();
                // debugger
                this.setPayTypeDict(ret);
            }
        },
        async getPayStatusDict(force, rootState) {
            const {cmDict} = rootState;
            let {payStatusDict} = cmDict;
            if (force || !!!payStatusDict || payStatusDict.length === 0) {
                let ret = await CmDictService.getPayStatusDict();
                this.setPayStatusDict(ret);
            }
        },
        async getWhOutStatusDict(force, rootState) {
            const {cmDict} = rootState;
            let {whOutStatusDict} = cmDict;
            if (force || !!!whOutStatusDict || whOutStatusDict.length === 0) {
                let ret = await CmDictService.getWhOutStatusDict();
                this.setWhOutStatusDict(ret);
            }
        },
        async getWhInStatusDict(force, rootState) {
            const {cmDict} = rootState;
            let {whInStatusDict} = cmDict;
            if (force || !!!whInStatusDict || whInStatusDict.length === 0) {
                let ret = await CmDictService.getWhInStatusDict();
                this.setWhInStatusDict(ret);
            }
        },
        //发票类型字典
        async getInvoiceTypeDict(force, rootState) {
            const {cmDict} = rootState;
            let {invoiceTypeDict} = cmDict;
            if (force || !!!invoiceTypeDict || invoiceTypeDict.length === 0) {
                let ret = await CmDictService.getInvoiceTypeDict();
                this.setInvoiceTypeDict(ret);
            }
        },
        //销售订单状态字典
        async getSaleOrderStatusDict(force, rootState) {
            const {cmDict} = rootState;
            let {saleOrderStatusDict} = cmDict;
            if (force || !!!saleOrderStatusDict || saleOrderStatusDict.length === 0) {
                let ret = await CmDictService.getSaleOrderStatusDict();
                this.setSaleOrderStatusDict(ret);
            }
        },
        //销售单状态字典
        async getSaleStatusDict(force, rootState) {
            const {cmDict} = rootState;
            let {saleStatusDict} = cmDict;
            if (force || !!!saleStatusDict || saleStatusDict.length === 0) {
                let ret = await CmDictService.getSaleStatusDict();
                this.setSaleStatusDict(ret);
            }
        },
        //销售退货单状态字典
        async getSaleReturnStatusDict(force, rootState) {
            const {cmDict} = rootState;
            let {saleReturnStatusDict} = cmDict;
            if (force || !!!saleReturnStatusDict || saleReturnStatusDict.length === 0) {

                let ret = await CmDictService.getSaleReturnStatusDict();
                this.setSaleReturnStatusDict(ret);
            }
        },
        //获取采购单类型
        async getPurchaseOrderTypeDict(force, rootState) {
            const {cmDict} = rootState;
            let {purchaseOrderTypeDict} = cmDict;
            if (force || !!!purchaseOrderTypeDict || purchaseOrderTypeDict.length === 0) {
                let ret = await CmDictService.getPurchaseOrderTypeDict();
                this.setPurchaseOrderTypeDict(ret);
            }
        },
        //采购订单状态字典
        async getPurchaseOrderStatusDict(force, rootState) {
            const {cmDict} = rootState;
            let {purchaseOrderStatusDict} = cmDict;
            if (force || !!!purchaseOrderStatusDict || purchaseOrderStatusDict.length === 0) {
                let ret = await CmDictService.getPurchaseOrderStatusDict();
                this.setPurchaseOrderStatusDict(ret);
            }
        },
        //采购发运单状态字典
        async getPurchaseInvoiceStatusDict(force, rootState) {
            const {cmDict} = rootState;
            let {purchaseInvoiceStatusDict} = cmDict;
            if (force || !!!purchaseInvoiceStatusDict || purchaseInvoiceStatusDict.length === 0) {
                let ret = await CmDictService.getPurchaseInvoiceStatusDict();
                this.setPurchaseInvoiceStatusDict(ret);
            }
        },
        //采购单状态字典
        async getPurchaseStatusDict(force, rootState) {
            const {cmDict} = rootState;
            let {purchaseStatusDict} = cmDict;
            if (force || !!!purchaseStatusDict || purchaseStatusDict.length === 0) {
                let ret = await CmDictService.getPurchaseStatusDict();
                this.setPurchaseStatusDict(ret);
            }
        },
        //采购退货单状态字典
        async getPurchaseReturnStatusDict(force, rootState) {
            const {cmDict} = rootState;
            let {purchaseReturnStatusDict} = cmDict;
            if (force || !!!purchaseReturnStatusDict || purchaseReturnStatusDict.length === 0) {
                let ret = await CmDictService.getPurchaseReturnStatusDict();
                this.setPurchaseReturnStatusDict(ret);
            }
        },
        //销售订单类型（常规、直发）
        async getSaleOrderTypeDict(force, rootState) {
            const {cmDict} = rootState;
            let {saleOrderTypeDict} = cmDict;
            if (force || !!!saleOrderTypeDict || saleOrderTypeDict.length === 0) {
                let ret = await CmDictService.getSaleOrderTypeDict();
                this.setSaleOrderTypeDict(ret);
            }
        },
        //销售价格类型（常规、直发）
        async getSalePriceTypeDict(force, rootState) {
            const {cmDict} = rootState;
            let {salePriceTypeDict} = cmDict;
            if (force || !!!salePriceTypeDict || salePriceTypeDict.length === 0) {
                let ret = await CmDictService.getSalePriceTypeDict();
                this.setSalePriceTypeDict(ret);
            }
        },
        //盘点状态
        async getStockCheckStatusDict(force, rootState) {
            const {cmDict} = rootState;
            let {stockCheckStatusDict} = cmDict;
            if (force || !!!stockCheckStatusDict || stockCheckStatusDict.length === 0) {
                let ret = await CmDictService.getStockCheckStatusDict();
                this.setStockCheckStatusDict(ret);
            }
        },
        //单据状态
        async getBillsTypeDict(force, rootState) {
            const {cmDict} = rootState;
            let {billsTypeDict} = cmDict;
            if (force || !!!billsTypeDict || billsTypeDict.length === 0) {
                let ret = await CmDictService.getBillsTypeDict();
                // console.log(ret)
                this.setBillsTypeDict(ret);
            }
        },
        //收款状态
        async getPayeeTypeDict(force, rootState) {
            const {cmDict} = rootState;
            let {payeeTypeDict} = cmDict;
            if (force || !!!payeeTypeDict || payeeTypeDict.length === 0) {
                let ret = await CmDictService.getPayeeTypeDict();
                // console.log(ret)
                this.setPayeeTypeDict(ret);
            }
        },
        async getSalePayStatusDict(force, rootState) {
            const {cmDict} = rootState;
            let {salePayStatusDict} = cmDict;
            if (force || !!!salePayStatusDict || salePayStatusDict.length === 0) {
                let ret = await CmDictService.getSalePayStatusDict();
                this.setSalePayStatusDict(ret);
            }
        },
        async getSaleReturnPayStatusDict(force, rootState) {
            const {cmDict} = rootState;
            let {saleReturnPayStatusDict} = cmDict;
            if (force || !!!saleReturnPayStatusDict || saleReturnPayStatusDict.length === 0) {
                let ret = await CmDictService.getSaleReturnPayStatusDict();
                this.setSaleReturnPayStatusDict(ret);
            }
        },
        async getPurchasePayStatusDict(force, rootState) {
            const {cmDict} = rootState;
            let {purchasePayStatusDict} = cmDict;
            if (force || !!!purchasePayStatusDict || purchasePayStatusDict.length === 0) {
                let ret = await CmDictService.getPurchasePayStatusDict();
                this.setPurchasePayStatusDict(ret);
            }
        },
        async getPurchaseReturnPayStatusDict(force, rootState) {
            const {cmDict} = rootState;
            let {purchaseReturnPayStatusDict} = cmDict;
            if (force || !!!purchaseReturnPayStatusDict || purchaseReturnPayStatusDict.length === 0) {
                let ret = await CmDictService.getPurchaseReturnPayStatusDict();
                this.setPurchaseReturnPayStatusDict(ret);
            }
        },
        async getOpnBankDict(force, rootState) {
            const {cmDict} = rootState;
            let {opnBankDict} = cmDict;
            if (force || !!!opnBankDict || opnBankDict.length === 0) {
                let ret = await CmDictService.getOpnBankDict();
                console.log(ret)
                this.setOpnBankDict(ret);
            }
        },
    })
}

export default cmDictModel;